export default {
  menuShow(){
    /*菜单显示方式*/
    if(document.body.clientWidth >= 768){
      this.showStyle = 'horizontal'
    }else {
      this.showStyle = 'vertical'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js